export default "__VITE_ASSET__ClFV6Kyp__"